import { TThunkAction } from '../../types/redux/thunk';
import { getComparison, IParameters } from './getComparison';
import { ELoadingStatus } from '../../types/redux/loadingStatus';

export function getComparisonSafe(parameters: IParameters): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const {
      props,
      comparison: { status },
    } = getState();

    if (status[parameters.compareType] === ELoadingStatus.Loading) {
      return;
    }

    const currentProps = props[parameters.compareType];
    if (currentProps && currentProps.length > 0) {
      return;
    }

    await dispatch(getComparison(parameters));
  };
}
